module.exports = __webpack_public_path__ + "static/media/stats-pic.b5c982f3.png";